import { TabsProps } from 'antd';

import Tabs from './tabs';

export type { TabsProps };
export default Tabs;
